import { Workbox } from 'workbox-window'
import { bootstrap as bootstrapNetworkCheck } from './components/network-check'

let updateTimer = -1
export const clearUpdateTimer = () => {
  clearInterval(updateTimer)
  updateTimer = -1
}

export const SW_SCOPE = '/'

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return null
  }

  const wb = new Workbox('/sw.js', {
    scope: SW_SCOPE,
  })

  wb.register().then((reg) => {
    bootstrapNetworkCheck()
    updateTimer = setInterval(() => {
      reg!.update()
      console.info('[workbox-window]: check update. ', new Date().toString())
    }, 60 * 1000)
  })

  wb.addEventListener('redundant', () => {
    clearUpdateTimer()
  })

  return {
    wb,
    precache({ projectName, manifest }: { projectName: string; manifest: Array<{ url: string; revision: string }> }) {
      const message = {
        type: 'SUB_APP_PRECACHE',
        projectName: projectName,
        manifest: manifest,
      }
      console.info('[workbox-window]: precache', message)
      return wb.messageSW(message)
    },
    clearCache() {
      const message = {
        type: 'CLEAN_CACHE',
        cacheNames: ['crm-backend-api-network-first'],
      }
      console.info('[workbox-window]: clearCache', message)
      return wb.messageSW(message)
    },
  }
}

export const unregisterServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return Promise.resolve(false)
  }

  return navigator.serviceWorker
    .getRegistration(SW_SCOPE)
    .then((registration) => (registration ? registration.unregister() : false))
    .then((unregistered) => {
      if (unregistered) {
        clearUpdateTimer()
      }

      return unregistered
    })
}
